<template>
  <div class="d-flex flex-grow-1">
    <div class="row">
      <div class="col-sm">
        <FormInput v-model="$v.product_stock.$model"
          id="product_stock"
          :ske="true"
          label="Productvoorraad:"

          :vuelidate="$v"
          fieldName="product_stock"
        />
      </div>
    </div>
  </div>
</template>

<script>

import FormInput from "../../../Inputs/FormInput.vue"

import setupForm from "../../../../mixins/setupForm"

const fields = ["product_stock"]

export default setupForm(fields, {
  components: {
    FormInput,
  },
})

</script>
